export const stylePaper = {
  margin: 10,
  padding: 10,
};
